<div class="row">

    <p-tabMenu [model]="tabmenu"></p-tabMenu>


</div>
<div class="row">
    <div class="col-md-12">
        <div class="card-box"
            style="background-color: white;border-top-right-radius:0px;border-top-left-radius: 0px;border-bottom-right-radius:0px;border-bottom-left-radius:0px;">
            <div style="margin-bottom: 5%;">

                <div style="float: right;">
                    <button type="button" pButton [routerLink]="['/', this.slug, base_url, 'compose-email']" label="Compose Email"></button>

                </div>
            </div>
            <div class="mat-elevation-z8">

                <p-menubar [model]="items">
                    <span style="padding-left: 3px;">Showing
                        {{total_message_count==0?0:(messages_per_page*(page_no-1)+1)}} -
                        {{minFn(messages_per_page*(page_no),total_message_count)}} of {{total_message_count}} </span>
                    <i class="fa fa-refresh"
                        style="cursor: pointer;margin-left: 3px;margin-right: 3px;font-size: 1.3rem" pTooltip="Refresh"
                        tooltipPosition="top" *ngIf="!MailChecking" (click)="GetUpdates()"></i>
                    <p-progressSpinner [style]="{width: '25px', height: '25px'}" *ngIf="MailChecking" strokeWidth="7">
                    </p-progressSpinner>

                    <i class="pi pi-chevron-left" (click)="prevPage()" pTooltip="Previous Page"
                        style="cursor: pointer;"></i>
                    <i class="pi pi-chevron-right" (click)="nextPage()" pTooltip="Next Page"
                        style="cursor: pointer;"></i>

                </p-menubar>




                <div class="table-responsive justify-content-center">
                    <p-table #dt [value]="messages" [rows]="10" [globalFilterFields]="['Date','From','Subject']"
                        [rowHover]="true" dataKey="id"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        [showCurrentPageReport]="true">
                        <ng-template pTemplate="caption">
                            <div class="p-d-flex p-ai-center p-jc-between">

                                <span class="p-input-icon-left">

                                    <input pInputText type="text"
                                        (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search"
                                        style="width:250px;margin-left:75%;" />
                                </span>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 100px;">
                                    <input type="checkbox" (click)="selectALL()" [value]="selected"
                                        [(ngModel)]="selected">
                                </th>
                                <th style="width: 100px;">
                                    <span class="mail-important"><i class="pi pi-star"
                                            style="color:rgb(250, 192, 3)"></i></span>
                                </th>

                                <th style="font-weight: bold;" class="notranslate">{{sentEnabled?'To':'From'}}</th>

                                <th style="font-weight: bold;">Subject</th>

                                <th style="font-weight: bold;">Date</th>


                            </tr>

                        </ng-template>
                        <ng-template pTemplate="body" let-m>
                            <tr>
                                <td class="tdentry" style="width: 100px;">

                                    <input type="checkbox" class="checkmail" [value]="m.selected"
                                        [(ngModel)]="m.selected" (click)="select(m.id)">
                                </td>
                                <td class="tdentry" style="width: 100px;" (click)="MailViewNavigation(m.message_id)">
                                    <span class="mail-important custom-nav-link">
                                        <i class="pi pi-star" *ngIf="m.flagged==true"
                                            style="color:rgb(250, 192, 3)"></i>
                                        <i class="pi pi-star-o" *ngIf="m.flagged==false"
                                            style="color:rgb(250, 192, 3)"></i>
                                    </span>
                                </td>
                                <td class="tdentry" class="name custom-nav-link" [style.font-weight]="m.read?300:600"
                                    (click)="MailViewNavigation(m.message_id)">{{sentEnabled?m.to:m.from}}</td>

                                <td class="tdentry" class="subject custom-nav-link" [style.font-weight]="m.read?300:600"
                                    (click)="MailViewNavigation(m.message_id)">{{m.subject}}</td>

                                <td class="tdentry" class="mail-date custom-nav-link"
                                    [style.font-weight]="m.read?300:600" (click)="MailViewNavigation(m.message_id)">
                                    {{m.date | date:'medium'}}</td>



                            </tr>

                        </ng-template>

                    </p-table>


                </div>
            </div>

        </div>

    </div>

</div>
<div *ngIf="response.success!=null && response.success==false" class="alert alert-danger">
    <p *ngIf="response.error!=null">{{response.error.message}}</p>
    <div *ngIf="serverError.error!=null && serverError.statusCode!=500">
        <p *ngFor="let message of serverError.message">{{message}}</p>
    </div>
    <div *ngIf="serverError.error!=null && serverError.statusCode===500">
        <p>{{serverError.message}}</p>
    </div>

</div>
